module.exports = __webpack_public_path__ + "static/img/day6.5e37cfa.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/multidaytours/tour1/day6.jpg
// module id = uc6q
// module chunks = 0